import script from "./UserRegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistrationView.vue?vue&type=style&index=0&id=1fe3025a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe3025a"]])

export default __exports__